// @flow
import type { Action } from 'app/common/redux/types';

export type State = {
  closeupCount: number,
  clickthroughCount: number,
  scrollCount: number,
};

const initialState = {
  closeupCount: 0,
  clickthroughCount: 0,
  scrollCount: 0,
};

export const UNAUTH_ACTION_TYPE = Object.freeze({
  CLICKTHROUGH: 'CLICKTHROUGH',
  CLOSEUP: 'CLOSEUP',
  DISMISS_MODAL: 'DISMISS_MODAL',
  SCROLL: 'SCROLL',
});

const modalBudgetReducer = (state: State = initialState, action: Action): State => {
  if (action.type === UNAUTH_ACTION_TYPE.CLICKTHROUGH) {
    state.clickthroughCount += 1;
  } else if (action.type === UNAUTH_ACTION_TYPE.CLOSEUP) {
    state.closeupCount += 1;
  } else if (action.type === UNAUTH_ACTION_TYPE.SCROLL) {
    state.scrollCount = action.payload;
  } else if (action.type === UNAUTH_ACTION_TYPE.DISMISS_MODAL) {
    // for now do nothing
  }

  return state;
};

export default modalBudgetReducer;
